import { UserHubASI as SharedUserHubASI } from "../devices/device.settings";

/** Legacy wrapper for /hub-asi/:id/asi-people/:id */
const UserHubASI = () => <SharedUserHubASI />;

export default UserHubASI;
